import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import ChangePhoto from "./change-photo.component";

interface ExpandAndChangePhotoProps {
  onChangePhoto?: () => void;
  onExpandPhoto?: () => void;
}

export default function ExpandAndChangePhoto({
  onChangePhoto,
  onExpandPhoto,
}: ExpandAndChangePhotoProps) {
  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        width: "100%",
        textAlign: "center",
        transform: "translate(-50%, -50%)",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          bottom: "-10px",
          left: "50%",
          transform: "translate(-50%, -50%)",
          cursor: "pointer",
        }}
        onClick={onExpandPhoto}
      >
        <AspectRatioIcon style={{ color: "white" }} />
        <Typography
          variant="caption"
          component="div"
          color="white"
          fontWeight={600}
        >
          Expand Photo
        </Typography>
      </Box>

      <ChangePhoto onChangePhoto={onChangePhoto} expandPhoto={true} />
    </Box>
  );
}
